import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the flat tire icon
 * 
 * @param {Object} props - The props of the component
 * @returns The flat tire icon
 */
const FlatTireIcon = (props) => (
  <Icon viewBox="0 0 16.838 15" {...props}>
    <defs>
      <clipPath id="clip-path">
        <rect width="16.838" height="15" fill="currentColor" />
      </clipPath>
    </defs>
    <g clipPath="url(#clip-path)">
      <path
        d="M47.874,14.267h-1.4a.243.243,0,0,1-.243-.243V7.4a.242.242,0,0,1,.243-.243h1.4a.243.243,0,0,1,.243.243v6.628a.243.243,0,0,1-.243.243"
        transform="translate(-38.754 -5.997)"
        fill="currentColor"
      />
      <path
        d="M47.874,63.469h-1.4a.243.243,0,0,1-.243-.243V62.106a.243.243,0,0,1,.243-.243h1.4a.243.243,0,0,1,.243.243v1.121a.243.243,0,0,1-.243.243"
        transform="translate(-38.754 -51.86)"
        fill="currentColor"
      />
      <path
        d="M14.39,1.6V.5a.5.5,0,0,0-.5-.5H13.4a.5.5,0,0,0-.5.5V2.248a.448.448,0,0,0,.151.332,6.936,6.936,0,0,1,.235,10.092.5.5,0,0,1-.354.143H3.915a.5.5,0,0,1-.354-.143A6.936,6.936,0,0,1,3.777,2.6a.505.505,0,0,0,.169-.373V.593h0V.5a.5.5,0,0,0-.5-.5H2.952a.5.5,0,0,0-.5.5V1.6a.5.5,0,0,1-.139.345,8.423,8.423,0,0,0-.7,10.741.5.5,0,0,1,.1.294V14.5a.5.5,0,0,0,.5.5h1.4a.5.5,0,0,0,.5-.5.5.5,0,0,1,.5-.5h.261a.5.5,0,0,1,.5.5.5.5,0,0,0,.5.5h.177a.5.5,0,0,0,.5-.5.5.5,0,0,1,.5-.5h.261a.5.5,0,0,1,.5.5.5.5,0,0,0,.5.5H8.5a.5.5,0,0,0,.5-.5.5.5,0,0,1,.5-.5h.261a.5.5,0,0,1,.5.5.5.5,0,0,0,.5.5h.177a.5.5,0,0,0,.5-.5.5.5,0,0,1,.5-.5h.261a.5.5,0,0,1,.5.5.5.5,0,0,0,.5.5h1.4a.5.5,0,0,0,.5-.5V12.982a.5.5,0,0,1,.1-.294,8.423,8.423,0,0,0-.7-10.741A.5.5,0,0,1,14.39,1.6"
        transform="translate(0 0)"
        fill="currentColor"
      />
    </g>
  </Icon>
);

export default React.memo(FlatTireIcon);
